import { useNavigate, useSearchParams } from 'react-router-dom'
import { Card, CardContent } from '@mui/material'
import * as Icons from '@mui/icons-material'
import { TpFullscreenFab } from '~/components/tp-fullscreen-fab'
import { MetricsContent } from './metrics-content'
import { useFeatures } from '~/common/use-features'
import { useState } from 'react'

export const MetricsCard = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { features } = useFeatures()
  const [isMouseOver, setIsMouseOver] = useState(false)

  const handleFullscreen = () => {
    const qs = searchParams.toString()
    navigate(`/metrics${qs ? `?${qs}` : ''}`)
  }

  return (
    <Card
      onMouseEnter={() => setIsMouseOver(true)}
      onMouseLeave={() => setIsMouseOver(false)}
      sx={{ height: '100%', display: 'flex', flexDirection: 'column', position: 'relative' }}
    >
      <CardContent
        sx={{
          p: 0,
          flex: 1,
          overflow: 'hidden',
          minHeight: 0,
          '&.MuiCardContent-root:last-child': { pb: 0 },
        }}
      >
        <MetricsContent />
      </CardContent>

      {features['page_metrics'] && isMouseOver && (
        <TpFullscreenFab onClick={handleFullscreen}>
          <Icons.Fullscreen />
        </TpFullscreenFab>
      )}
    </Card>
  )
}
